import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const InputCounter = () => {
  const [count1, setCount1] = useState(1);
  const [count2, setCount2] = useState(5);
  const [count3, setCount3] = useState(0);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC COUNTERS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Basic Counters</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Counter</label>
            <div className="flex items-center gap-2">
              <button onClick={() => setCount1(Math.max(1, count1 - 1))} className="px-3 py-2 bg-slate-700 hover:bg-slate-600 rounded"></button>
              <input type="number" value={count1} readOnly className="w-16 px-2 py-2 border border-slate-600 rounded bg-slate-950 text-center" />
              <button onClick={() => setCount1(count1 + 1)} className="px-3 py-2 bg-slate-700 hover:bg-slate-600 rounded">+</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-center gap-2">
  <button className="px-3 py-2 bg-slate-700"></button>
  <input type="number" value={count} className="w-16 px-2 border rounded" />
  <button className="px-3 py-2 bg-slate-700">+</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Styled Counter</label>
            <div className="flex items-center gap-2 border border-slate-600 rounded-lg p-1">
              <button className="px-3 py-1 text-sm hover:bg-slate-700 rounded"></button>
              <span className="flex-1 text-center text-sm font-medium">{count2}</span>
              <button className="px-3 py-1 text-sm hover:bg-slate-700 rounded">+</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-center gap-2 border rounded-lg p-1">
  <button className="px-3 py-1"></button>
  <span className="flex-1 text-center">{count}</span>
  <button className="px-3 py-1">+</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Vertical Counter</label>
            <div className="flex flex-col items-center gap-1">
              <button className="px-3 py-1 hover:bg-slate-700 rounded"></button>
              <input type="number" value={count3} readOnly className="w-12 px-2 py-1 border border-slate-600 rounded bg-slate-950 text-center" />
              <button className="px-3 py-1 hover:bg-slate-700 rounded"></button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex flex-col items-center gap-1">
  <button></button>
  <input type="number" />
  <button></button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Label</label>
            <div>
              <span className="text-xs text-slate-400 block mb-2">Quantity:</span>
              <div className="flex items-center gap-2">
                <button className="px-2 py-1 bg-slate-700 rounded text-sm"></button>
                <span className="px-3 py-1 border border-slate-600 rounded min-w-[40px] text-center">3</span>
                <button className="px-2 py-1 bg-slate-700 rounded text-sm">+</button>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div>
  <span className="text-xs">Quantity:</span>
  <div className="flex items-center gap-2">
    <button></button>
    <span>{count}</span>
    <button>+</button>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Large Counter</label>
            <div className="flex items-center gap-3">
              <button className="px-4 py-3 bg-slate-700 hover:bg-slate-600 rounded-lg text-lg"></button>
              <input type="number" value={5} readOnly className="w-20 px-3 py-3 border border-slate-600 rounded-lg bg-slate-950 text-center text-lg font-bold" />
              <button className="px-4 py-3 bg-slate-700 hover:bg-slate-600 rounded-lg text-lg">+</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-center gap-3">
  <button className="px-4 py-3 text-lg"></button>
  <input className="w-20 px-3 py-3 text-lg" />
  <button className="px-4 py-3 text-lg">+</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Mini Counter</label>
            <div className="flex items-center gap-1 w-fit">
              <button className="px-2 py-0.5 bg-slate-700 text-xs rounded"></button>
              <span className="px-2 py-0.5 border border-slate-600 rounded min-w-[30px] text-center text-xs">2</span>
              <button className="px-2 py-0.5 bg-slate-700 text-xs rounded">+</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-center gap-1">
  <button className="px-2 py-0.5 text-xs"></button>
  <span className="text-xs">Count</span>
  <button className="px-2 py-0.5 text-xs">+</button>
</div>`} />
          </div>
        </div>
      </div>

      {/* COLORED COUNTERS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Colored Variants</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Cyan Counter</label>
            <div className="flex items-center gap-2 border border-amber-600 rounded-lg p-1">
              <button className="px-3 py-1 text-amber-400 hover:bg-amber-900"></button>
              <span className="flex-1 text-center text-amber-400 font-bold">7</span>
              <button className="px-3 py-1 text-amber-400 hover:bg-amber-900">+</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="border border-amber-600">
  <button className="text-amber-400"></button>
  <span className="text-amber-400">Count</span>
  <button className="text-amber-400">+</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Purple Counter</label>
            <div className="flex items-center gap-2 border-2 border-amber-600 rounded-lg p-2">
              <button className="px-3 py-1 text-amber-400 hover:bg-amber-900"></button>
              <span className="flex-1 text-center text-amber-400 font-bold">4</span>
              <button className="px-3 py-1 text-amber-400 hover:bg-amber-900">+</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="border-2 border-amber-600">
  <button className="text-amber-400"></button>
  <span className="text-amber-400">Count</span>
  <button className="text-amber-400">+</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Gradient</label>
            <div className="flex items-center gap-2 rounded-lg p-1 bg-gradient-to-r from-slate-700 to-slate-800">
              <button className="px-3 py-1 text-sm"></button>
              <span className="flex-1 text-center font-bold">6</span>
              <button className="px-3 py-1 text-sm">+</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-gradient-to-r from-slate-700 to-slate-800 rounded-lg">
  <button></button>
  <span>Count</span>
  <button>+</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Shadow Variant</label>
            <div className="flex items-center gap-2 rounded-lg p-2 shadow-lg bg-slate-800">
              <button className="px-3 py-1 hover:bg-slate-700 rounded"></button>
              <span className="flex-1 text-center font-bold">9</span>
              <button className="px-3 py-1 hover:bg-slate-700 rounded">+</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="shadow-lg rounded-lg p-2">
  <button></button>
  <span>Count</span>
  <button>+</button>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputCounter;


